import { render } from "./MessageStats.vue?vue&type=template&id=758ff676&scoped=true&ts=true"
import script from "./MessageStats.vue?vue&type=script&lang=ts"
export * from "./MessageStats.vue?vue&type=script&lang=ts"

import "./MessageStats.vue?vue&type=style&index=0&id=758ff676&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758ff676"]])

export default __exports__